import { supabase, clearActiveOrgOverride } from '../supabaseClient'

// Auth helpers
export const getCurrentUser = async () => {
  try {

    // Add timeout to prevent infinite hanging
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('getCurrentUser timeout')), 5000);
    });

    const authPromise = supabase.auth.getUser();

    const { data: { user } } = await Promise.race([authPromise, timeoutPromise]);
    return user;
  } catch (error) {
    return null; // Return null instead of throwing
  }
}

export const signInCoach = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  })
  return { data, error }
}

export const signOut = async () => {
  clearActiveOrgOverride()
  const { error } = await supabase.auth.signOut()
  return { error }
}

// Envia el correo de recuperacion de contrasena. El redirect vuelve al
// entorno desde donde se solicito (local/qa/prod), todos en la allow-list.
export const sendPasswordReset = async (email) => {
  const redirectTo = `${window.location.origin}/reset-password`
  const { data, error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo })
  return { data, error }
}

// Staff data (coaches, managers, etc.)
// knownUser: si el llamador ya tiene el usuario (ej. session.user del callback
// de onAuthStateChange), pasarlo evita una segunda llamada a auth.getUser()
// que dentro de ese callback puede deadlockear en supabase-js v2.
export const getCurrentStaff = async (knownUser = null) => {
  const user = knownUser || await getCurrentUser()
  if (!user) return { data: null, error: null }

  // Resolver staff solo por identidad verificada (auth_user_id / email del JWT).
  // Se elimina la rama por user_metadata.staff_id (editable por el usuario → spoof).
  const orFilters = []

  if (user.email) {
    // ilike without % behaves as case-insensitive equality
    orFilters.push(`email.ilike.${user.email}`)
  }
  if (user.id) {
    orFilters.push(`auth_user_id.eq.${user.id}`)
  }

  let query = supabase
    .from('staff')
    .select('*')
    .limit(1)

  if (orFilters.length > 0) {
    query = query.or(orFilters.join(','))
  }

  const { data, error } = await query.maybeSingle()

  return { data, error }
}

// Backward compatibility
export const getCurrentCoach = getCurrentStaff
